
<template>
  <el-timeline style="margin-left: 10px" class="timeline-detail">
    <template v-for="(activity, index) in props.records" :key="index">
      <el-timeline-item
        size="large"
        v-if="!(activity.type == 1 && activity.nodeCopyDTOList?.length < 1)"
      >
        <template #dot>
          <div class="avatar_node">
            <el-avatar :size="30" :src="circleUrl" />
          </div>
        </template>

        <div class="content">
          <div>
            <div v-if="activity.type === 0">
              <span>
                {{
                  `${$store.state?.user?.realName}${activity.type === 3 ? "重新" : ""}提交的${
                    props.typeName
                  }申请`
                }}
              </span>
            </div>
            <template v-else>
              <span>{{ activity.name }}</span>
              <span>({{ getName(activity) || "-" }})</span>
            </template>
          </div>
        </div>
      </el-timeline-item>
    </template>
  </el-timeline>
</template>

<script setup>
import { inject } from "vue"
const $store = inject("$store")
const props = defineProps({
  records: {
    type: Array,
    default: () => [],
  },
  typeName: {
    type: String,
    default: "",
  },
})
const circleUrl = "https://cube.elemecdn.com/3/7c/3ea6beec64369c2642b92c6726f1epng.png"
const getName = item => {
  let name = ""
  if (item.type == 1) {
    name = item.nodeCopyDTOList.map(current => current.name).join(",")
  } else {
    name = item.nodeIdentityDTOList.map(current => current.name).join(",")
  }
  return name
}
</script>
<style lang="less" scoped></style>
